module.exports = __webpack_public_path__ + "static/media/inbox.7c1b13e1.svg";